__turbopack_context__.v({
  "base": "base-module__zoujya__base",
  "checklist": "base-module__zoujya__checklist",
  "editorContainer": "base-module__zoujya__editorContainer",
  "inlineImage": "base-module__zoujya__inlineImage",
  "link": "base-module__zoujya__link",
  "listItemChecked": "base-module__zoujya__listItemChecked",
  "listItemUnchecked": "base-module__zoujya__listItemUnchecked",
  "nestedListItem": "base-module__zoujya__nestedListItem",
  "strikethrough": "base-module__zoujya__strikethrough",
  "table": "base-module__zoujya__table",
  "tableCell": "base-module__zoujya__tableCell",
  "tableCellHeader": "base-module__zoujya__tableCellHeader",
  "tableCellResizer": "base-module__zoujya__tableCellResizer",
  "tableCellSelected": "base-module__zoujya__tableCellSelected",
  "tableScrollableWrapper": "base-module__zoujya__tableScrollableWrapper",
  "tableSelected": "base-module__zoujya__tableSelected",
  "tableSelection": "base-module__zoujya__tableSelection",
  "underline": "base-module__zoujya__underline",
  "underlineStrikethrough": "base-module__zoujya__underlineStrikethrough",
});
